import React from 'react';

export const pageMeta = {
  "name": "JSON Parse",
  "link": "/javascript/json/parse"
};

export default function JavascriptJsonParse() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JSON Parse</h2>
      <p>Route: /javascript/json/parse</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
